// Breadcrumb — THE clickable-path renderer (merged with the former PathCrumbs,
// 2026-08-21 — README's own "two components, one job" flag on 'the path' role,
// resolved). One job, one component: a row of labels separated by CRUMB_SEP,
// non-last segments (or any segment with onClick) clickable to jump up.
//
//   crumbs: Array<{ label: string, onClick?: () => void }>
//     Segments with onClick are clickable links to jump up. A crumb's onClick
//     always stopPropagation()s first — PathCrumbs needed this (it renders
//     inside clickable DataGrid rows, where a bare click would also fire the
//     row's own click-to-select/edit) and it's harmless for the header case,
//     so it lives once here rather than each of the merged callers redoing it.
//     The current location has no onClick (plain text).
//   dense — the former PathCrumbs weight: muted small mono text, no <nav>
//           landmark (a grid can render one of these per row — a real <nav>
//           per row would be an aria-label collision, not a landmark).
//           Default false = the page-header weight (bold, body-size, in a
//           <nav aria-label="Breadcrumb">) that Breadcrumb always rendered.
//           The two weights are a real, deliberate difference (page header
//           vs. inline grid cell), not drift — same reasoning as BTN_TAB's
//           two button weights in theme-tokens.js.

import { CRUMB_SEP } from '../icons.js';

export default function Breadcrumb({ crumbs, dense = false }) {
  if (!crumbs || crumbs.length === 0) return null;
  const Wrap = dense ? 'span' : 'nav';
  const wrapProps = dense
    ? { style: { display: 'inline-flex', alignItems: 'center', flexWrap: 'wrap', gap: 2, color: 'var(--th-text-disabled)', fontSize: 'var(--fs-small)' } }
    : { 'aria-label': 'Breadcrumb', style: { display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2, fontSize: 'var(--fs-body)' } };
  return (
    <Wrap {...wrapProps}>
      {crumbs.map((crumb, i) => (
        <span key={i} style={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          {i > 0 && (
            <span aria-hidden="true" style={{ color: dense ? 'var(--th-border-subtle)' : 'var(--th-text-muted)', padding: '0 2px', fontSize: dense ? 'var(--fs-mono)' : 'var(--fs-small)' }}>{CRUMB_SEP}</span>
          )}
          {crumb.onClick ? (
            <button
              onClick={e => { e.stopPropagation(); crumb.onClick(); }}
              style={dense ? {
                background: 'none', border: 'none', padding: 0, cursor: 'pointer',
                fontFamily: 'var(--ff-mono)', fontSize: 'var(--fs-mono)', color: 'var(--th-navy)',
                textDecoration: 'underline', textDecorationColor: 'var(--th-border-subtle)',
              } : {
                background: 'none', border: 'none', padding: 0,
                cursor: 'pointer', color: 'var(--th-accent)',
                fontWeight: 600, fontSize: 'var(--fs-body)',
                textDecoration: 'underline', textUnderlineOffset: 2,
              }}
            >
              {crumb.label}
            </button>
          ) : (
            <span style={dense
              ? { fontFamily: 'var(--ff-mono)', fontSize: 'var(--fs-mono)' }
              : { color: 'var(--th-text-body)', fontWeight: 600, fontSize: 'var(--fs-body)' }}
            >
              {crumb.label}
            </span>
          )}
        </span>
      ))}
    </Wrap>
  );
}
